import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3d0de95a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3d0de95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0de95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0de95a')) {
      api.createRecord('3d0de95a', component.options)
    } else {
      api.reload('3d0de95a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3d0de95a&scoped=true&", function () {
      api.rerender('3d0de95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28e3WUjVL6GD6/JS/teamMember.vue"
export default component.exports